import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ColorizeIcon = ({ size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="34 34 31 31"
    >
      <g>
        <path fill="#F39322" d="M60,50c0,2.8-1.1,5.3-2.9,7.1l3.5,3.5C63.4,57.9,65,54.2,65,50H60z" />
        <path fill="#8CC047" d="M50,40v-5c-4.1,0-7.9,1.7-10.6,4.4L43,43C44.8,41.1,47.3,40,50,40z" />
        <path fill="#F9B233" d="M60,50h5c0-4.1-1.7-7.9-4.4-10.6L57.1,43C58.9,44.8,60,47.3,60,50z" />
        <path fill="#DDCF42" d="M57.1,43l3.5-3.5C57.9,36.7,54.2,35,50,35v5C52.8,40,55.3,41.1,57.1,43z" />
        <path fill="#A3195B" d="M43,57.1l-3.5,3.5C42.2,63.3,45.9,65,50,65v-5C47.3,60,44.8,58.9,43,57.1z" />
        <path fill="#F22727" d="M50,60v5c4.1,0,7.9-1.7,10.6-4.4l-3.5-3.5C55.3,58.9,52.8,60,50,60z" />
        <path fill="#143F4C" d="M40,50h-5c0,4.1,1.7,7.9,4.4,10.6l3.5-3.5C41.2,55.3,40,52.8,40,50z" />
        <path fill="#228881" d="M43,43l-3.5-3.5C36.7,42.1,35,45.9,35,50h5C40,47.3,41.2,44.8,43,43z" />
        <path fill="#FAC58A" d="M53.6,53.6l3.5,3.5c1.8-1.8,2.9-4.3,2.9-7.1h-5C55,51.4,54.5,52.7,53.6,53.6z" />
        <path fill="#BBD89F" d="M50,45v-5c-2.8,0-5.3,1.1-7.1,2.9l3.5,3.5C47.4,45.6,48.7,45,50,45z" />
        <path fill="#F7D6A1" d="M53.6,46.5c0.9,0.9,1.5,2.2,1.5,3.5h5c0-2.8-1.1-5.3-2.9-7.1L53.6,46.5z" />
        <path fill="#EDE58D" d="M53.6,46.5l3.5-3.5C55.3,41.1,52.8,40,50,40v5C51.4,45,52.7,45.6,53.6,46.5z" />
        <path fill="#A07089" d="M46.5,53.6L43,57.1c1.8,1.8,4.3,2.9,7.1,2.9v-5C48.7,55,47.4,54.5,46.5,53.6z" />
        <path fill="#FA9090" d="M50,55v5c2.8,0,5.3-1.1,7.1-2.9l-3.5-3.5C52.7,54.5,51.4,55,50,55z" />
        <path fill="#257689" d="M45,50h-5c0,2.8,1.1,5.3,2.9,7.1l3.5-3.5C45.6,52.7,45,51.4,45,50z" />
        <path fill="#59BAB5" d="M46.5,46.5L43,43C41.2,44.8,40,47.3,40,50h5C45,48.6,45.6,47.4,46.5,46.5z" />
      </g>
    </svg>
  </CircledIcon>
);
